import { MeQuery } from '@/generated/graphql'
import { createContext } from 'react'

interface ContextValue {
  isInitializing: boolean
  userId: string | undefined
  isAuthenticated: boolean
  isLoading: boolean
  user: MeQuery['me'] | undefined
  login: ({
    email,
    password,
  }: {
    email: string
    password: string
  }) => Promise<void>
  loginWithCode: (email: string) => Promise<void>
  confirmCode: (code: string) => Promise<void>
  confirmNewPassword: (newPassword: string) => Promise<void>
  logout: () => Promise<void>
}

const INITIAL_STATE: ContextValue = {
  isInitializing: false,
  userId: undefined,
  isAuthenticated: false,
  isLoading: false,
  user: undefined,
  login: () => Promise.resolve(),
  loginWithCode: () => Promise.resolve(),
  confirmCode: () => Promise.resolve(),
  confirmNewPassword: () => Promise.resolve(),
  logout: () => Promise.resolve(),
}

export const AuthContext = createContext<ContextValue>(INITIAL_STATE)
